module.exports = __webpack_public_path__ + "img/broadband-providers.f40c169.webp";